import { TagApi } from '@movilizame/networking';

export class ChoferesApi {

    constructor (net, list) {
        this.net = new TagApi(net, list);
    }

    /**
     * Devuelve el estado actual del chofer
     */
    estado () {
        return this.net.get('/api/conductor/v2/estado');
    }
    /**
     * Devuelve el estado actual del chofer
     */
    arriboDestino () {
        return this.net.get('/api/conductor/arribo-destino');
    }

    /**
     * Devuelve un listado de viajes
     * @param {object} data
     * @param {Date} data.desde
     * @param {Date} data.hasta
     */
    listado (data) {
        return this.net.get('/api/conductor/listado', data);
    }

    reservas () {
        return this.net.get('/api/conductor/reservas');
    }
    /**
     * Devuelve la cuenta corriente del chofer
     * @param {object} data
     * @param {Date} data.desde
     * @param {Date} data.hasta
     */
    cuentaCorriente (data) {
        return this.net.get('/api/conductor/cuentaCorriente', data);
    }

    /**
     * Devuelve los conductores en pánico
     */

    driverInPanic () {
        return this.net.get('/api/conductor/choferes-panico');
    }

    /**
     * turn on or off panic mode
     */

    panic () {
        return this.net.post('/api/conductor/panico');
    }

    /**
     * Cambia la disponibilidad del conductor
     * @param {booleam} estado
     */

    changeState (data) {
        return this.net.post('/api/conductor/estado', data);
    }

    /**
     * Cambia los datos del perfil
     * @param {object} data
     * @param {Date} data.radio_recepcion
     * @param {Date} data.telefono
     * @param {Date} data.password
     * @param {Date} data.password_confirmation
     */
    changeProfile (data) {
        return this.net.post('/api/conductor/usuario', data);
    }

    /**
     * Listado de vehiculos
     */

    vehiculos (data) {
        return this.net.get('/api/conductor/vehiculo', data);
    }

    /***
     * Indica la posicion del auto. Solo para testing
     *
     { "location": { "coords": { "latitude":    -32.941348, "longitude": -60.711379, }, "timestamp": "2016-07-18T22:36:14.610Z"}
     *
     **/

    location (data) {
        var postData = '';
        // data.lat = Math.random() + data.lat;
        // data.lng = -Math.random() + data.lng;
        if (!data.latitude) {
            postData += '0[latitude]=' + data.lat;
        }

        if (!data.longitude) {
            postData += '&0[longitude]=' + data.lng;
        }

        // return this.net.post('/conductor/coordenadas', data);

        let headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };

        return this.net.post('/api/conductor/coordenadas', postData, headers);
    }

    /***
     * Listado de viajes ofrecidos
     **/

    ofrecidos (data) {
        return this.net.get('/api/conductor/ofrecidos', data);
    }

    /***
     * Aceptar un viaje ofrecido
     *
     * @pre  Viaje creado y en estado pendiente
     * @data @viaje_id
     *       @comentario [Debería ser obligatorio si el viaje tiene chofer asignado a un viaje]
     *       @lat
     *       @lng
     *
     **/

    acceptTrip (data) {
        return this.net.post('/api/conductor/aceptar', data);
    }

    /***
     * Ignorar un viaje ofrecido
     *
     * @pre  Viaje creado y en estado pendiente
     * @data @viaje_id
     *       @comentario [Debería ser obligatorio si el viaje tiene chofer asignado a un viaje]
     *       @lat
     *       @lng
     *
     **/

    ignoreTrip (data) {
        return this.net.post('/api/conductor/ignorar', data);
    }

    /***
     * Actualizar precio
     *
     * @pre  Actualiza el precio de un viaje segun recargo
     * @data @viaje_id
     *       @precio
     *
     **/

    updateTripPrice (data) {
        return this.net.post('/api/conductor/actualizarPrecio', data);
    }

    /***
     * Avisar que estoy llegnado
     *
     * @pre  Viaje creado y en estado pendiente
     * @data @viaje_id or null (busca el viaje actual)
     *       @comentario [Debería ser obligatorio si el viaje tiene chofer asignado a un viaje]
     *       @lat
     *       @lng
     *
     **/

    llegandoTrip (data) {
        return this.net.post('/api/conductor/llegando', data);
    }

    /***
     * Cancela el viaje actual
     *
     * @pre  Viaje creado y en estado pendiente
     * @data @viaje_id or null (busca el viaje actual)
     *       @comentario [Debería ser obligatorio si el viaje tiene conductor asignado a un viaje]
     *       @lat
     *       @lng
     *
     **/

    cancelTrip (data) {
        return this.net.post('/api/conductor/cancelar', data);
    }

    /***
     * Marca como visto el viaje cancelado
     *
     * @pre  Tener un viaje recien cancelado
     * @data
     *
     **/

    markCancelTrip (id) {
        let data = null;
        if (id) {
            data = {
                viaje_id: id
            };
        }
        return this.net.post('/api/conductor/viaje-cancelado-visto', data);
    }

    /***
     * Indicar que te subiste a un viaje
     *
     * @pre  Algun conductor haya aceptado el viaje.
     * @data @viaje_id or null (busca el viaje actual)
     *       @comentario
     *       @lat
     *       @lng
     *
     **/

    takeTrip (data) {
        return this.net.post('/api/conductor/abordar', data);
    }

    /***
     * Indicar que se termino el viaje
     *
     * @pre  Estar subido a un viaje
     * @data @viaje_id or null (busca el viaje actual)
     *       @comentario
     *       @lat
     *       @lng
     *
     **/

    endTrip (data) {
        return this.net.post('/api/conductor/finalizar', data);
    }

}



// WEBPACK FOOTER //
// ./src/services/api/ChoferesApi.js